import React, { useState, useEffect } from "react";
import axios from "axios";
import Sorting from "../../services/Sorting";
import styles from "../../styles/CommentShow.module.css";

function CommentsShow({ postId, onCommentAdded }) {
  const [comments, setComments] = useState([]);
  const [error, setError] = useState(null);

  // Funzione per caricare i commenti
  const fetchComments = async () => {
    try {
      const authToken = localStorage.getItem("AuthToken");
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}postsComments/${postId}`,
        {
          headers: {
            authToken: authToken,
          },
        }
      );

      console.log("Commenti ricevuti dal server:", response.data); // Aggiungi questo log per vedere i dati
      setComments(
        response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )
      ); // Salva i commenti nello stato
    } catch (err) {
      console.error("Errore nel caricamento dei commenti:", err);
      setError(err);
    }
  };

  useEffect(() => {
    if (postId) {
      fetchComments();
    }
  }, [postId]);

  if (error) {
    return <div>Errore nel caricamento dei commenti.</div>;
  }

  return (
    <div className={styles}>
      {/* <h1>Commenti</h1> */}
      {comments.length > 0 ? (
        comments.map(({ id, comment, createdAt, user }) => (
          <div key={id} className={styles.comment}>
            <p className={styles.username}>
              <strong>{user?.username || "Utente sconosciuto"}</strong>{" "}
            </p>
            <p className={styles.commentText}>{comment}</p>
            <span className={styles.timestamp}>
              Pubblicato il {new Date(createdAt).toLocaleDateString()} alle{" "}
              {new Date(createdAt).toLocaleTimeString()}
            </span>
          </div>
        ))
      ) : (
        <p className={styles.noComments}>Nessun commento disponibile.</p>
      )}
    </div>
  );
}

export default CommentsShow;
